import React, { useState, useEffect } from "react";
import { fetchAlumEvents } from "../components/apifa";

const UpEvents = () => {
  const [eventsData, setEventsData] = useState([]); // State to store fetched events data
  const [loading, setLoading] = useState(true); // State to manage loading state
  const [error, setError] = useState(null); // State to manage errors

  useEffect(() => {
    const fetchData = async () => {
      try {
        const events = await fetchAlumEvents(); // Fetch the alumni events
        console.log(events);
        setEventsData(events); // Set fetched events in state
      } catch (error) {
        setError("Error fetching events data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []); // Empty dependency array ensures this runs once on component mount

  if (loading) {
    return <p>Loading events...</p>; // Show loading text while data is being fetched
  }

  if (error) {
    return <p>{error}</p>; // Show error message if something went wrong
  }

  return (
    <section className="w-full flex flex-col justify-start items-center bg-white text-[#f7c612] py-16">
    <div className="text-center mb-12">
      <h2 className="text-3xl md:text-5xl font-bold mb-4 mx-4 sm:mx-8">
        Upcoming Events
      </h2>
      <p className="text-lg md:text-xl mb-10 mx-4 sm:mx-8">
        Stay updated with the latest events and gatherings happening soon.
        Don't miss out on the action!
      </p>
    </div>
  
    <div className="flex flex-col items-center py-5 w-full">
      <div className="justify-items-center w-full">
        {eventsData.map(({ title, date, time, description }, index) => (
          <div
            key={index}
            className="bg-gray-800 rounded-lg p-6 shadow-lg flex flex-col justify-between items-center h-full w-full max-w-[400px]" // Limit width of each card
          >
            <div className="flex flex-col justify-between flex-1 mb-4 md:mb-0 md:mr-6 h-full">
              <div>
                <h3 className="text-2xl font-semibold text-lime-300 mb-2">
                  {title}
                </h3>
                <div className="flex items-center text-lg font-medium mb-2">
                  <span className="text-lime-300">{date}</span>
                  <span className="mx-2">|</span>
                  <span className="text-gray-400">{time}</span>
                </div>
                {description && (
                  <p className="mb-4 text-lg text-gray-300">{description}</p>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
  
  );
};

export default UpEvents;
